import React from "react";
import "./Menu.scss";
import PictureInitials from "./PictureInitials/PictureInitials";
import hermesLogoHoriz from "../assets/hermes-logo.png";
import { NavLink, useLocation } from "react-router-dom";

// Inspired on: https://www.codingnepalweb.com/create-sidebar-menu-html-css-javascript/

const TabsNavLink = ({ to, matchStates, children }) => {
  const location = useLocation();

  // Custom active logic: Match the path and ensure the activeTab matches
  const isActive =
    location.pathname === to && // Path matches
    matchStates.includes(location.state?.activeTab);

  return (
    <NavLink
      to={to}
      className={
        ({ isActive: navIsActive }) =>
          navIsActive && isActive ? "nav-link active" : "nav-link" // Both conditions must be true
      }
      state={{ activeTab: matchStates[0] }} // Ensure correct activeTab is passed
    >
      {children}
    </NavLink>
  );
};

const Menu = ({ dashboardData }) => {
  return (
    <div className="menu">
      <header className="menu-header">
        <a href="#" className="header-logo">
          <img src={hermesLogoHoriz} alt="Hermes Motorsport" />
        </a>
      </header>

      <div className="menu-profile">
        <div className="profile-image">
          <PictureInitials
            first_name={dashboardData?.user.first_name}
            last_name={dashboardData?.user.last_name}
          />
        </div>
        <div className="profile-info">
          <p>
            {dashboardData?.user.first_name} {dashboardData?.user.last_name}
          </p>
          <p>
            {dashboardData?.user.car}{" "}
            {dashboardData?.user.car ? <span>-</span> : ""}{" "}
            {dashboardData?.user.championship}
          </p>
        </div>
      </div>

      <nav className="menu-nav">
        {/* Primary bottom nav */}
        <ul className="nav-list primary-nav">
          <li className="nav-item">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <span className="nav-icon material-symbols-rounded">speed</span>
              <span className="nav-label">Dashboard</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <TabsNavLink to="/settings" matchStates={[0]}>
              <span className="nav-icon material-symbols-rounded">move_up</span>
              <span className="nav-label">Data sources</span>
            </TabsNavLink>
          </li>
          <li className="nav-item">
            <TabsNavLink to="/settings" matchStates={[1, 2]}>
              <span className="nav-icon material-symbols-rounded">
                settings
              </span>
              <span className="nav-label">Settings</span>
            </TabsNavLink>
          </li>
        </ul>

        {/* Secondary bottom nav */}
        <ul className="nav-list secondary-nav">
          <li className="nav-item">
            <a
              href="https://dedalotechnologies-my.sharepoint.com/:b:/p/mguanter/Ee6z8dLgQsNAhrIkGV0CujEB8tl8-mgg_AO7C87PsWcfxQ?e=DTetXq"
              target="_blank"
              className="nav-link"
            >
              <span className="nav-icon material-symbols-rounded">Help</span>
              <span className="nav-label">Support</span>
            </a>
          </li>
          <li className="nav-item">
            <a
              href="https://forms.office.com/Pages/ResponsePage.aspx?id=kkqWLlg9e0-m1dChda_lXmthPAopviZBh_pYOMEVEftURDBKUFNNTTAzQ01TVEY4Uzk5UjNVVjBWVC4u"
              target="_blank"
              className="nav-link"
            >
              <span className="nav-icon material-symbols-rounded">
                bug_report
              </span>
              <span className="nav-label">Report a bug</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Menu;
